<div class="custom-snack-bar-container {{getTypeClassname()}}" >
    <mat-icon fontSet="phr-iconset" [ngClass]="getIconClassname()"></mat-icon>
    <span>{{text}}</span>
    <button mat-icon-button (click)="onClose()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-close"></mat-icon>
    </button>
</div>